goog.provide('el8.appchart.dialog.selectDate');

goog.require('el8.service.tz');
goog.require('el8.template.appchart.dialog.setDateTime');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.consts');
goog.require('el8.util.validate');


el8.appchart.dialog.selectDate = (function() {
    var saveCb = null;

    var defaultDate = null;

    var DEFAULT_TITLE = 'Select Date';
    
    var that = new el8.uiwidget.FormDialog({
        title: DEFAULT_TITLE,
        autoHeight: true,
        width: 300,
        modal: true,
        contentFn: function() {
            return el8.template.appchart.dialog.setDateTime.content({hideTime: true});
        }
    });
    
    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'date',
                selector: ':input[name="date"]',
                infoText: 'date...',
                datePickerOpts: {},
                validate: {
                    validDate: true,
                    afterYear1900: true
                }
            }
        ],
        validationOpts: el8.util.validate.standardOpts
    });
    form.addSaveButton(function() {
        if (!form.isValid()) { return; }
        if (saveCb) { saveCb(form.getVal('date')); }
        that.hide();
    }, true);
    form.addCancelButton(function() {
        that.hide();
    });
    that.setForm(form);
    
    var super_show = that.show;
    that.show = function(opts) {
        super_show.call(that);
        
        saveCb = opts.saveCallbackFn || null;
        if (opts.hasOwnProperty('defaultDate')) { // allow defaultDate to be null
            defaultDate = opts.defaultDate;
        } else {
            defaultDate = el8.service.tz.today();
        }

        if (defaultDate) { form.setVal('date', defaultDate.asString()); }
        if (opts.title) { that.setTitle(opts.title); }
        if (opts.msg) { $('.optional-explanation', that.getContentElt()).text(opts.msg); }
    };

    var super_hide = that.hide;
    that.hide = function() {
        saveCb = null;
        defaultDate = null;

        that.setTitle(DEFAULT_TITLE);
        super_hide.call(that);
        $('.optional-explanation', that.getContentElt()).empty();
    };
    
    return that;
    
})();
